module.exports = __webpack_public_path__ + "static/media/discover.6bc87ccd.png";